<template>
  <section class="contact-section">
    <!-- <div class="map-container">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d417288.1305817083!2d-80.81947864045998!3d35.20488672333432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88541fc4fc381a81%3A0x884650e6bf43d164!2sCharlotte%2C%20NC%2C%20USA!5e0!3m2!1sen!2sua!4v1762283698452!5m2!1sen!2sua" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div> -->
	 <div class="map-container">
	   <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d441858.68379248056!2d-80.8365499201327!3d35.249439538994245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885426a52f3a488d%3A0xe7f16f331f9fffbd!2sCharlotte%20Metropolitan%20Area%2C%20USA!5e0!3m2!1sen!2sua!4v1766425085199!5m2!1sen!2sua" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
	 </div>
  </section>
</template>

<script>
export default {
  name: 'MapView',
};
</script>

<style lang="scss" scoped>
.contact-section {
  padding: 0 20px;
  text-align: center;
  color: #333;
}

.map-container {
  margin-top: 25px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}
</style>
